import React from "react";

const TICKER = [
  "MARKET PROFILE",
  "ORDER FLOW",
  "FOOTPRINT",
  "VALUE AREA",
  "POC",
  "INITIAL BALANCE",
  "DELTA / CVD",
  "ABSORPTION",
  "AUCTION THEORY",
  "RISK MANAGEMENT",
  "PSYCHOLOGY",
  "INSTITUTIONAL SETUPS",
];

export default function Marquee() {
  const items = [...TICKER, ...TICKER];
  return (
    <div
      data-testid="marquee"
      className="border-y border-[#0A0A0A] bg-[#0A0A0A] text-[#F4F3ED] overflow-hidden py-3"
    >
      <div className="marquee-track whitespace-nowrap">
        {items.map((t, i) => (
          <span
            key={i}
            className="font-mono-acc text-[11px] tracking-[0.35em] uppercase mx-8 inline-flex items-center gap-8"
          >
            {t}
            <span className="text-[#D9381E]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
